/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState, useCallback } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./Chatbot.scss";
import appSettings from "../../appSettings";

function ChatbotBase({ toggleChatbot, openChatbot, username, groupName }) {
    const [showFlyout, setShowFlyout] = useState(false);
    const [chatbotLoaded, setChatbotLoaded] = useState(false);

    const toggleFlyout = useCallback(() => {
        setShowFlyout((prev) => !prev);
        toggleChatbot();
    }, [toggleChatbot]);

    useEffect(() => {
        setShowFlyout(openChatbot);
    }, [openChatbot]);

    useEffect(() => {
        loadChatbot();
        setChatbotLoaded(true);
    }, []);

    function loadChatbot() {
        document.getElementById("web-chat-script")?.remove();
        const chatBot = document.createElement("script");
        Object.assign(chatBot, {
            id: "web-chat-script",
            type: "text/javascript",
            async: true,
            src: appSettings.CHATBOT_URL,
            defer: true,
        });
        if (username) {
            chatBot.setAttribute("username", username);
        }
        if (groupName) {
            chatBot.setAttribute("groupname", groupName);
        }
        document.head.appendChild(chatBot);
    }

    return (
        <div id="chatbot-container" className="sticky-fab-container">
            <ChatbotFlyout onClose={toggleFlyout} chatbotLoaded={chatbotLoaded} showFlyout={showFlyout}/>
            <ChatbotButton onClick={toggleFlyout}  showFlyout={showFlyout}/>
        </div>
    );
}

function ChatbotFlyout({onClose, chatbotLoaded, showFlyout }) {
    return (
        <div id="chatbot-flyout" className="sticky-fab-flyout" style={{ display: showFlyout ? "block" : "none" }}>
            <div id="chatbot-header" className="chatbot-fab-flyout-header">
                <ChatbotIcon />
                <div className="fab-flyout-title">American Modern Chat</div>
                <button className="close-chatbot-fab-flyout" onClick={onClose}>
                    <CloseIcon fontSize="small" />
                </button>
            </div>
            <div id="chatbot-content" className="chatbot-flyout-content">
                {chatbotLoaded && <div id="webchat" className="chatbot" role="main"></div>}
            </div>
        </div>
    );
}

function ChatbotButton({ onClick, showFlyout}) {
    return (
        <button id="chatbot" className="chatbot-sticky-fab" onClick={onClick} style={{ display: !showFlyout ? "block" : "none" }}>
            <img src={require("../../common/assets/img/chatbot-icon.png")} alt="Contact us" />
        </button>
    );
}

function ChatbotIcon() {
    return (
        <div className="chatbot-flyout-icon">
            <img className="desktop-flyout-icon" src={require("../../common/assets/img/chatbot-icon.png")} alt="Contact us" />
            <img className="mobile-flyout-icon" src={require("../../common/assets/img/chatbot-green.png")} alt="Contact us" />
        </div>
    );
}


export default ChatbotBase;